// @flow
// import { Base64 } from 'js-base64';
import { encodeProduct } from '../../modules/featured-products/utils/encode';

import type { ProductList, ProductListItem } from '../../entities';

const populateItem = (item: ProductListItem) => {
  const r = { ...item };
  /*const r = {...item};
  const i = {...item};*/
  // if (!r.scrappable) {
  r.b64 = encodeProduct(item);
  // }
  return r;
};

export const populateProductListItems = (productList: ProductList): ProductList => {
  const products = productList.products.map((x: ProductListItem) => populateItem(x));
  const relatedProducts = productList.relatedProducts.map((x: ProductListItem) => populateItem(x));
  return { ...productList, products, relatedProducts };
};



// WEBPACK FOOTER //
// ./src/modules/product-list/utils.js